import "@/utils/svgAnimatedStringShim"; // строго первым: до загрузки v-tooltip
import Vue from "vue";
import App from "./App";
import router from "./router";
import { store } from "./store/store";
import axios from "axios";
import VueAxios from "vue-axios";
// import firebase from "firebase/app";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vuetify, { vuetifyLocaleFor } from "./plugins/vuetify";
import { VueMaskDirective } from "v-mask";
import ReadMore from "vue-read-more";
import VTooltip from "v-tooltip";
import JsonExcel from "vue-json-excel";
import BetaChip from "@/components/common/BetaChip.vue";
// import IdleVue from 'idle-vue'
import { initCable } from "@/cable";
import { buildCableUrl, createCableUrlFn, resolveCableBaseFromStore } from "@/helpers/cable";
import { isTrustedApiUrl } from "@/utils/apiRegionAllowlist";
// import DatePicker from "v-calendar/lib/components/date-picker.umd";
import VCalendar from 'v-calendar';
import "./registerServiceWorker";
import fullscreen from "vue-fullscreen";
import GmapVue from "gmap-vue";
import { components } from "gmap-vue";
const { Cluster: GmapCluster } = components;
import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");
// Rollbar собираем из штатных компонентов 3.x (exports пакета, тип Components в
// index.d.ts) — это тот же набор, что в src/browser/rollbar.js, минус tracing.
// Почему без tracing (ревью vue#516, свежий агент): в 3.1.0 telemeter при наличии
// tracing заводит span «rollbar-telemetry» и пушит в него КАЖДОЕ событие телеметрии
// (XHR, console, клики, навигация) без лимита — даже при tracing.enabled:false.
// Завершает span только session replay, которого у нас нет; end() к тому же не
// освобождает память, а переносит span в модульную очередь spanExportQueue, которую
// дренирует опять же только replay. Для вкладки/WebView, живущих сутками, это
// ~250 Б на событие без потолка. Без компонента tracing span не создаётся вовсе,
// плюс не пишется sessionStorage.RollbarSession и в payload нет session_id —
// ни то, ни другое нам не нужно. Вернуть tracing — импортировать
// rollbar/src/tracing/tracing и добавить в setComponents, когда апстрим закроет
// https://github.com/rollbar/rollbar.js/issues/1479 (репро и разбор — там).
import Rollbar from "rollbar/src/browser/core";
import rollbarScrub from "rollbar/src/scrub";
import RollbarTelemeter from "rollbar/src/telemetry";
import rollbarTruncation from "rollbar/src/truncation";
import RollbarInstrumenter from "rollbar/src/browser/telemetry";
import rollbarWrapGlobals from "rollbar/src/browser/wrapGlobals";
import { ROLLBAR_SCRUB_FIELDS } from "@/utils/rollbarScrubFields";
import { rollbarCheckIgnore } from "@/utils/rollbarIgnore";
import { rollbarTransform } from "@/utils/rollbarTransform";
import { Crisp } from "crisp-sdk-web";
// import OneSignalVue from "onesignal-vue";
import VueSignaturePad from "vue-signature-pad";

import VueTimeago from 'vue-timeago'
import VueCountdown from '@chenfengyuan/vue-countdown';

import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import i18n from "./i18n";

import Notifications from './plugins/notifications';
import ConfirmDialog from './plugins/confirmDialog';
import { isStaleChunkWindowError, reloadOnceForStaleChunk } from '@/helpers/staleChunk';
import { captureHandoffFragment } from "@/utils/handoffFragment";
// import AntiScrapingProtection from './plugins/anti-scraping';
// import { NewRelicCapacitorPlugin, NREnums, AgentConfiguration } from '@newrelic/newrelic-capacitor-plugin';
import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";
import { installDeepLinkHandler } from "@/router/deepLink";
import { installHardwareBackHandler } from "@/utils/hardwareBack";
import { installRestoreListener } from "@/services/nativeCamera";
// import { Stripe } from '@capacitor-community/stripe';

// Universal / app links: ссылка https://web.rentprog.* открыла приложение →
// ведём роутер по её пути. Слушатель ставится здесь, а не в AppHeader:
// AppHeader не рендерится без сессии, а ссылка сброса пароля приходит именно
// туда. Ставим до создания Vue: событие холодного старта Capacitor доставляет
// при первой подписке (iOS — retainUntilConsumed в AppPlugin.swift, Android —
// replay intent в BridgeActivity.load → retainedEventArguments). Подробности —
// src/router/deepLink.js.
if (Capacitor.isNativePlatform()) {
  installDeepLinkHandler(CapacitorApp, router);
}

// Системное «назад» Android (кнопка и жест): слой → история → свернуть.
// Один слушатель на всё приложение — см. src/utils/hardwareBack.js.
if (Capacitor.getPlatform() === "android") {
  installHardwareBackHandler(CapacitorApp, router);
}

// FT-186 REQ-04: снимок, сделанный, пока Android убивал приложение, приходит событием
// холодного старта — слушатель ставится до Vue по той же причине, что appUrlOpen выше.
if (Capacitor.getPlatform() === "android") {
  installRestoreListener(CapacitorApp, router);
}

// initialize stripe
// Stripe.initialize({
//   publishableKey: "pk_live_51KtQkKFNgvJ2eyx925rNt6rX9DwYTt6TrcsGIjfIeE7gZWPNSgg4pEC3NKI4tJKiPqgMytdYPPHQ8WhYXtb9Ka9o00htarW7FH",
//   // publishableKey: "pk_test_51KtQkKFNgvJ2eyx9Z3T7j3jeQU5V9QAMvMWVhjtpdXEcKVwsRgMvTHYCMPFKP2W7sQ74Xl5ykB8NndRd3sCQaUd6002xUquz6s",
// });


// FT-098 [REQ-10a]: снять handoff-фрагмент ДО конструирования сторонних SDK.
// Порядок здесь критичен — см. комментарий в самом модуле.
captureHandoffFragment();

Vue.component(VueCountdown.name, VueCountdown);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import VueCookieAcceptDecline from "vue-cookie-accept-decline";
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";

Vue.component("vue-cookie-accept-decline", VueCookieAcceptDecline);

Vue.use(wysiwyg, {
  maxWidth: "700px",
  // image: {
  //   uploadURL: "/api/myEndpoint",
  //   dropzoneOptions: {}
  // },
});

import { ru, enUS, pt, ptBR } from "date-fns/locale";

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'enUS', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    ru: ru,
    en: enUS,
    pt: pt,
    "pt-BR": ptBR,
  }
})

// Rollbar
// code_version — короткий git SHA сборки (см. vue.config.js). Должен совпадать с
// `version`, под которым source-map загружается в Rollbar (deploy_ru.sh / stage-deploy.sh),
// иначе стектрейсы останутся минифицированными.
const rollbarCodeVersion =
  process.env.VUE_APP_GIT_SHA || process.env.VUE_APP_VERSION || "unknown";

// environment по API-хосту, а НЕ по NODE_ENV: staging собирается с NODE_ENV=production
// (.env.staging), поэтому по NODE_ENV его ошибки маскировались бы под production.
const rollbarApiUrl = process.env.VUE_APP_API_URL || "";
const rollbarEnvironment =
  process.env.NODE_ENV === "development"
    ? "development"
    : rollbarApiUrl.includes("rentprog.pro")
    ? "staging"
    : "production";

Rollbar.setComponents({
  telemeter: RollbarTelemeter,
  instrumenter: RollbarInstrumenter,
  wrapGlobals: rollbarWrapGlobals,
  scrub: rollbarScrub,
  truncation: rollbarTruncation,
});

// rollbar_token — публичный post_client_item токен (по дизайну уезжает в браузер).
// Переопределяется VUE_APP_ROLLBAR_TOKEN при необходимости; иначе — дефолт проекта.
Vue.prototype.$rollbar = new Rollbar({
  accessToken:
    process.env.VUE_APP_ROLLBAR_TOKEN || "0d8e65c1fc2c46c7adbf3ffb755fa662",
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: process.env.NODE_ENV === "production",
  environment: rollbarEnvironment,
  payload: {
    // code_version на верхнем уровне — используется Rollbar как «версия» релиза.
    code_version: rollbarCodeVersion,
    client: {
      javascript: {
        // Даёт Rollbar применять загруженные source-map к минифицированным трейсам.
        code_version: rollbarCodeVersion,
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
  // Шум браузерных расширений (AdBlock и т.п.) — не баги приложения.
  // Эти сообщения код страницы физически породить не может.
  ignoredMessages: [
    "A listener indicated an asynchronous response by returning true, but the message channel closed before a response was received",
    "The message port closed before a response was received",
    "Extension context invalidated",
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
  ],

  // Логика в src/utils/rollbarIgnore.js (вынесена для тестируемости):
  // инъекции расширений + целиком чужие origin'ы (issue #126, crisp.chat).
  checkIgnore: rollbarCheckIgnore,

  // Логика в src/utils/rollbarTransform.js (там же — почему): транзиентная
  // сетевая ошибка уходит warning'ом даже когда прилетела UNCAUGHT, минуя
  // $reportError. Инцидент 2026-09-08, Rollbar f52f91d8.
  transform: rollbarTransform,

  // Не больше 10 событий за загрузку страницы (дефолт 0 — без потолка; есть только
  // 60/мин). Неполная JS-среда бота (нет SVGAnimatedString) роняла каждый
  // v-tooltip на /clients — десятки событий за загрузку, весь месячный лимит
  // Rollbar ушёл на один IP (2026-10-02). На 11-м Rollbar шлёт одно сообщение
  // «maxItems has been hit» — что потолок сработал, видно.
  maxItems: 10,

  // FT-200: пара входа в кабинет клиента — см. src/utils/rollbarScrubFields.js.
  scrubFields: ROLLBAR_SCRUB_FIELDS,

  // rollbar 3.x: session replay (отдельный бандл `rollbar/replay`, +250 KB) и
  // propagation-заголовок `baggage` (нужен tracing + enabledCorsUrls, добавил бы
  // заголовок к запросам на api) выключены дефолтами и здесь осознанно не включаются;
  // tracing снят на уровне компонентов — см. импорты выше.
});
Vue.config.errorHandler = (err, vm, info) => {
  vm.$rollbar.error(err);
  throw err; // rethrow
};

// Единая точка репортинга для setError-обработчиков компонентов: транзиентные
// сетевые ошибки (обрыв/таймаут/офлайн мобильных клиентов) уходят warning-ом,
// чтобы не топить Rollbar шумом; всё остальное — error, как раньше.
import { isTransientNetworkError } from "@/utils/networkErrors";
Vue.prototype.$reportError = function (text, error) {
  if (isTransientNetworkError(error)) {
    this.$rollbar.warning(text, error);
  } else {
    this.$rollbar.error(text, error);
  }
};

// Канонический this.setError для всех компонентов (заменил 108 копипастных
// копий). Локальное определение в компоненте перекрыло бы mixin-метод.
import setErrorMixin from "@/mixins/setErrorMixin";
Vue.mixin(setErrorMixin);

// Канонические ролевые проверки (isStaff/isAgent/isPartner/isGuest, user_role,
// requireStaff) — тем же способом и по той же причине, что setError выше.
import roleMixin from "@/mixins/roleMixin";
Vue.mixin(roleMixin);

// Канонические footer-props таблиц (tableFooterProps) — тем же способом и по
// той же причине: ~80 копипастных объектов, мобильный футер чинится в одном месте.
import tableFooterMixin from "@/mixins/tableFooterMixin";
Vue.mixin(tableFooterMixin);

// Ссылки на страницы справки (docsLink(path)) — тем же способом: ~30 кнопок «?» по разделам
// раньше собирали адрес helpcenter лендинга каждая сама (src/mixins/docsLinkMixin.js).
import docsLinkMixin from "@/mixins/docsLinkMixin";
Vue.mixin(docsLinkMixin);

// Опция компонента pullToRefresh включает жест «потяни, чтобы обновить», пока
// компонент смонтирован (см. src/utils/pullToRefresh.js).
import { pullToRefreshMixin } from "@/utils/pullToRefresh";
Vue.mixin(pullToRefreshMixin);

// Устаревший SPA-shell: провал загрузки ленивого чанка после передеплоя может прилететь
// UNCAUGHT (сервер вернул 200 + index.html вместо js/<chunk>.<hash>.js → браузер парсит
// `<!DOCTYPE html>` как JS → SyntaxError), т.е. webpack не увидел import как rejected и
// router.onError не сработал. Узкий листенер ловит только SyntaxError из /js/*.js и делает
// тот же guarded-reload (не чаще раза в 10с). См. @/helpers/staleChunk.
window.addEventListener("error", (event) => {
  if (isStaleChunkWindowError(event)) {
    reloadOnceForStaleChunk();
  }
});

Vue.use(VueSignaturePad);
// Vue.component("vc-date-picker", DatePicker);
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />          // ...other defaults
});

// FT-018 STEP-10: cable URL helpers live in @/helpers/cable (shared with CableReconnect mixin).

// Определяем API URL: сохранённый региональный или дефолтный.
// FT-018: build-time override через VUE_APP_API_URL ENV (.env.development /
// .env.staging / .env.production). Если VUE_APP_API_URL не задан — fallback
// на hardcoded production URL (для backward-compat со старыми builds где
// .env.production был пустой).
//
// Post-review fix (architect-review P0): non-development build без
// VUE_APP_API_URL = misconfigured. Логируем error чтобы было видно в console
// если staging/EU build silently fall на rentprog.net.
const envApiUrl = process.env.VUE_APP_API_URL;
let defaultApiUrl;
if (envApiUrl) {
  defaultApiUrl = envApiUrl;
} else if (process.env.NODE_ENV === "development") {
  // Хост из origin страницы: браузер → localhost, live-reload на девайсе →
  // LAN-IP мака (та же логика, что в utils/apiBase.js).
  defaultApiUrl = `http://${window.location.hostname}:3000`;
} else {
  defaultApiUrl = "https://rentprog.net";
  console.error(
    "[region/bootstrap] VUE_APP_API_URL empty in non-development build — " +
    "falling back to https://rentprog.net. Check .env.<mode> resolution.",
  );
}
const savedApiUrlRaw = (process.env.NODE_ENV !== "development" && localStorage.getItem("vuex") && JSON.parse(localStorage.getItem("vuex")).api_url) || null;
// Гард инцидента 2026-08-26: персист мог быть отравлен адресом чужого
// окружения (стендовая сборка в APK) — тогда каждый старт приложения снова
// сажал axios на стенд. Адрес вне allowlist (origin сборки +
// VUE_APP_TRUSTED_API_ORIGINS, куда лягут канонические EU/RU API при
// разделении) отбрасывается в пользу build-time дефолта. Громко: это
// единственная точка, где отравленный персист виден один раз за запуск.
const savedApiUrl = savedApiUrlRaw && isTrustedApiUrl(savedApiUrlRaw, defaultApiUrl) ? savedApiUrlRaw : null;
if (savedApiUrlRaw && !savedApiUrl) {
  console.error("[region/bootstrap] rejected persisted api_url outside the trusted allowlist:", savedApiUrlRaw);
}
const savedRegion = (localStorage.getItem("vuex") && JSON.parse(localStorage.getItem("vuex")).region) || null;
const apiUrl = savedApiUrl || defaultApiUrl;
// SEC-01 / FT-066: the actual tokenized boot URL is now produced lazily by createCableUrlFn
// (see below) and re-evaluated by the native consumer on each (re)connect. Here we only
// derive the untokenized base for the bootstrap log (never log the token).
const cableBaseUrl = buildCableUrl(apiUrl);
if (process.env.NODE_ENV !== "production") {
  console.log("[region] bootstrap", {
    env: process.env.NODE_ENV,
    envApiUrl,
    savedRegion,
    savedApiUrl,
    defaultApiUrl,
    apiUrl,
    cableUrl: cableBaseUrl, // SECURITY: log the untokenized base, never the token
  });
}

// FT-066: native @rails/actioncable. The consumer re-evaluates the URL function on every
// (re)connect, so region + token are always fresh (CableReconnect just triggers
// reconnect/disconnect). Native connects lazily on the first subscription (boot channels
// subscribe on AppHeader mount). SECURITY: never log the tokenized URL. Base URL rules
// (development → API host, regional URL when mapped) live in resolveCableBase.
// FT-215: the URL also carries the build version and platform (anonymous-connection log on the API).
// Закрытая сменой сотрудника вкладка сокет не держит; если переподключение всё же случится — без токена (FT-191 REQ-09).
const cableToken = () => (store.getters['deviceLock/tabClosed'] ? null : localStorage.getItem("auth_token"));
initCable(createCableUrlFn({
  resolveBase: () => resolveCableBaseFromStore(store, process.env.NODE_ENV),
  getToken: cableToken,
  getVersion: () => appVersionInfo.version,
  getPlatform: () => Capacitor.getPlatform(),
}));

Vue.component("downloadExcel", JsonExcel);
Vue.component("loading", Loading);
// Пейволл-оверлей «не входит в тариф» — используется на ~11 страницах.
Vue.component("PlanGate", () => import("@/components/common/PlanGate.vue"));
// Бейдж «BETA» у заголовков разделов в бета-версии.
Vue.component("BetaChip", BetaChip);
// Vue.use(VueMoment);
Vue.directive("mask", VueMaskDirective);

Vue.use(Notifications);
Vue.use(ConfirmDialog, { vuetify, i18n });
// Vue.use(AntiScrapingProtection);

Vue.config.productionTip = false;
Vue.config.ignoredElements = [...(Vue.config.ignoredElements || []), /^rentprog-/];
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = apiUrl;
// Глобальный таймаут: без него зависший на плохой мобильной сети запрос жил
// 100+ секунд до OS-таймаута. Долгие операции (генерация/выгрузка файлов)
// переопределяют per-call через { timeout: ... }.
Vue.axios.defaults.timeout = DEFAULT_TIMEOUT_MS;

// Тихий авторетрай транзиентных сетевых обрывов (мобильные сети мигают на
// секунды — see shouldRetryRequest: только GET/HEAD/OPTIONS, POST не ретраим,
// чтобы не продублировать записи). Backoff ~1с/~2с с джиттером даёт сети
// время восстановиться, пользователь чаще всего ничего не замечает.
import axiosRetry from "axios-retry";
import { shouldRetryRequest, createNetworkFlagInterceptor, DEFAULT_TIMEOUT_MS } from "@/utils/networkErrors";
axiosRetry(Vue.axios, {
  retries: 2,
  retryDelay: (retryCount, error) => axiosRetry.exponentialDelay(retryCount, error, 1000),
  retryCondition: shouldRetryRequest,
  shouldResetTimeout: true,
});

// Глобальный баннер «Проблема с сетью» (App.vue): флаг взводится на
// транзиентных сетевых ошибках, первый успешный ответ снимает его сам.
const networkFlag = createNetworkFlagInterceptor(store);
Vue.axios.interceptors.response.use(networkFlag.onSuccess, networkFlag.onError);

// Anti-scraping: отправляем client_token и версию с каждым запросом
import appVersionInfo from '@/version.js';
import {
  shouldRefreshClientToken,
  recoverAfterForbidden,
  applyClientTokenHeader,
} from '@/utils/antiScrapeRetry';
// FT-136: факт «сессия мертва» устанавливается один раз, чистой функцией. Здесь —
// только проводка: снимок на отправке и вызов обработчика на 401. Логика решения
// живёт в модуле, потому что main.js не импортируется ни одним спеком.
import { stampRequest, handleSessionDeath } from '@/utils/sessionExpiry';
import { readDeviceSecret, readLastActivity, shouldBootLock, deviceAuthFailureAction, markBootedLocked } from '@/utils/deviceLock';
import { emitDeviceEvent } from '@/utils/deviceTabs';
import { startDeviceIdleTracker, closeStaleDeviceTab, currentIdleSeconds, noteIdleHeaderSent } from '@/services/deviceIdleTracker';
import { createRequestHeadersInterceptor } from '@/utils/requestHeaders';
import { createMoneyConfirmGuard } from '@/utils/moneyConfirmGuard';
import { isOurApiRequest } from '@/utils/apiOrigin';
import { shouldRecoverClientToken, shouldRetryWithStoredToken } from '@/utils/retryDecisions';
import { DEFAULT_API_BASE } from '@/utils/apiBase';
import { trustedApiOrigins } from '@/utils/apiRegionAllowlist';
import { printAgentNotice } from '@/utils/agentNotice';

// Все базы, которые в этой сессии могут оказаться нашим API. Собирается на
// каждый запрос, а не один раз: региональная база приезжает после логина и
// сбрасывается в unsetCurrentUser (store.js:476).
function ourApiBases() {
  return [
    Vue.axios.defaults.baseURL,
    store.getters.getApiUrl,
    store.state.api_url,
    process.env.VUE_APP_API_URL,
    DEFAULT_API_BASE,
    ...trustedApiOrigins(DEFAULT_API_BASE),
  ];
}

function pageOrigin() {
  return typeof window !== 'undefined' && window.location ? window.location.origin : null;
}

function targetsOurApi(config) {
  return isOurApiRequest(config, { bases: ourApiBases(), pageOrigin: pageOrigin() });
}

// FT-136 (CTR-06): признак снимается на МОМЕНТ ОТПРАВКИ и живёт на config. В момент
// ответа его считать поздно: первый же истинный вердикт обнуляет стор и сбрасывает
// axios.defaults.baseURL на дефолтный (store.js), после чего ответы 2..N параллельных
// региональных запросов сравнивались бы уже с другой базой. Адресата определяет
// предикат из @/utils/apiOrigin — тот же, что решает судьбу заголовков.
var applyRequestHeaders = createRequestHeadersInterceptor({
    // Простановка client_token — утилитой анти-скрейпинга, а не своим кодом:
    // повтор после рекавери проходит через этот же интерцептор, и без общей
    // метки TOKEN_APPLIED_FLAG он затирал бы только что полученный токен
    // значением из localStorage (инвариант #316).
    applyClientToken: function (config) { return applyClientTokenHeader(config); },
    getStoredAuthToken: function () { return localStorage.getItem('auth_token'); },
    getAppVersion: function () { return appVersionInfo.version; },
    getOurApiBases: ourApiBases,
    getPageOrigin: pageOrigin,
    // Наши собственные токены — по ним чужой запрос отличает «наш JWT затесался
    // из defaults» от «вызов сам поставил ключ стороннего сервиса». Первый
    // снимается, второй обязан дойти нетронутым.
    // FT-191: заголовки общего компьютера — геттерами, значения меняются по ходу сессии.
    getDeviceSecret: function () { return readDeviceSecret(); },
    getDeviceMode: function () { return store.getters['deviceLock/deviceMode']; },
    getIdleSeconds: function () { return currentIdleSeconds(); },
    onIdleHeaderSent: function () { noteIdleHeaderSent(); },
    getOwnAuthTokens: function () {
      return [
        Vue.axios.defaults.headers.common['Authorization'],
        localStorage.getItem('auth_token'),
        store.getters.getAuthToken,
      ];
    },
  });
Vue.axios.interceptors.request.use(function (config) {
  // FT-191 REQ-09: вкладка, закрытая сменой сотрудника, не говорит с API — иначе страница прежнего
  // сотрудника под оверлеем работала бы токеном нового (в т.ч. повтором 401 с токеном из хранилища).
  if (store.getters['deviceLock/tabClosed'] && targetsOurApi(config)) {
    return Promise.reject(new axios.Cancel('device tab closed'));
  }
  var prepared = applyRequestHeaders(config);
  var storedToken = localStorage.getItem('auth_token');
  stampRequest(prepared, {
    sessionActive: store.getters.isLoggedIn,
    hasStoredToken: !!(storedToken && storedToken !== 'null'),
    apiOrigin: targetsOurApi(prepared),
  });
  return prepared;
});

// Мягкий валютный рубеж: необычно крупная сумма спрашивает подтверждения ДО отправки.
// Отдельным интерцептором, а не внутри предыдущего: тот синхронный и служебный
// (заголовки, штампы), этот асинхронный и может отменить запрос. Смешивать их значило
// бы сделать асинхронной всю проводку заголовков ради редкой ветки.
//
// Логика и пороги вынесены в утилиты: интерцептор в отрыве от приложения не поднять,
// а покрыть тестами это надо — ровно тот довод, по которому здесь уже живёт
// recoverAfterForbidden (см. обработчик ответов ниже).
Vue.axios.interceptors.request.use(
  createMoneyConfirmGuard({
    getCompany: function () {
      return store.getters.getCompany;
    },
    confirm: function (config) {
      return Vue.prototype.$confirm(config);
    },
    translate: function (key, params) {
      return i18n.t(key, params);
    },
  })
);

// Обработка ошибок
Vue.axios.interceptors.response.use(
  function (response) {
    // Сбрасываем maintenance mode при успешном ответе
    if (store.state.maintenanceMode) {
      store.commit("setMaintenanceMode", false);
    }
    return response;
  },
  function (error) {
    // Anti-scraping: при 403 обновляем client_token и повторяем запрос.
    // И условие, и сам рекавери живут в утилите — там же разбор инцидента
    // 2026-08-24 с рекурсией по app_version, дедупликация параллельных походов
    // за токеном и регрессионные тесты (tests/unit/antiScrapeRetryLoop.spec.js).
    // Здесь остаётся только проводка axios: без неё рекавери был бы непокрыт
    // тестами — код жил бы внутри интерцептора, который в отрыве от всего
    // приложения не поднять.
    //
    // shouldRecoverClientToken добавляет к их условию проверку адресата: на
    // чужой 403 рекавери сходило бы за свежим client_token на наш app_version
    // и подставило бы его в повтор запроса к третьей стороне.
    if (shouldRecoverClientToken(error, targetsOurApi)) {
      return recoverAfterForbidden(error, Vue.axios);
    }

    // Maintenance mode — 503 от API
    if (
      error.response &&
      error.response?.status === 503 &&
      error.response?.data &&
      error.response?.data.error === "maintenance"
    ) {
      store.commit("setMaintenanceMode", true);
      return Promise.reject(error);
    }

    // Сбрасываем maintenance mode при любом успешном/другом ответе
    if (store.state.maintenanceMode && error.response && error.response?.status !== 503) {
      store.commit("setMaintenanceMode", false);
    }

    if (error.response && error.response?.status === 401) {
      // Прежде чем разлогинивать: первый 401 после refresh обычно означает, что запрос
      // ушёл БЕЗ токена (axios.defaults.Authorization не восстановлен после гидрации,
      // либо заголовок пришёл как "null"), а НЕ что токен невалиден. Один раз ретраим
      // с токеном из localStorage. Условие ретрая переехало в утилиту вместе со снятым
      // маршрутным guard'ом — иначе POST users/sign_in с неверным паролем повторялся бы
      // вторым запросом.
      var lsToken = localStorage.getItem("auth_token");
      // FT-191: до повтора и до «сессия мертва» — не страница ли это прежнего сотрудника общего
      // компьютера: тогда ни повтора чужим токеном, ни стирания общего хранилища, ни рассылки lock.
      if (store.getters['deviceLock/deviceMode']) {
        var deviceAction = deviceAuthFailureAction({
          tabClosed: store.getters['deviceLock/tabClosed'],
          storedToken: lsToken,
          currentUserId: store.state.currentUser && store.state.currentUser.id,
        });
        if (deviceAction === 'stale') closeStaleDeviceTab(store);
        if (deviceAction !== 'lock') return Promise.reject(error);
      }
      if (shouldRetryWithStoredToken(error, lsToken, targetsOurApi)) {
        error.config._authRetried = true;
        error.config.headers["Authorization"] = lsToken;
        return Vue.axios(error.config);
      }
      // Сравнений по текущему маршруту здесь больше нет: к этому моменту он
      // недетерминирован (unsetCurrentUser синхронно уводит на форму входа), а сам
      // guard был сломан — сравнивал путь с "/reset_password", тогда как маршрут
      // объявлен как "/reset_password/:token", и равенство не выполнялось никогда.
      // Отсутствие этих сравнений — предмет проверки CHK-04 (греп по main.js).
      // Кого разлогинивать, решает классификатор по свойствам запроса и ответа —
      // это и есть REQ-02 FT-136, ради которого #318 оставил разлогин без предиката
      // origin: два канона решения об одном и том же были бы хуже.
      // FT-191 CTR-05: на общем компьютере мёртвая текущая сессия — экран блокировки, а не
      // «сессия истекла» с выходом; тот же классификатор, другое действие.
      if (store.getters['deviceLock/deviceMode']) {
        handleSessionDeath(error, {
          // Сессия устройства мертва для всех вкладок — блокируются все, а не только получившая 401.
          logout: function () {
            const userId = store.state.currentUser && store.state.currentUser.id;
            store.dispatch('deviceLock/lockLocal', { userId });
            emitDeviceEvent('lock', { userId });
          },
        });
        return Promise.reject(error);
      }
      handleSessionDeath(error, {
        notify: function () {
          Vue.prototype.$notify(
            i18n.t("errors.attention"),
            i18n.t("errors.session_expired"),
            "warning",
            6000
          );
        },
        logout: function () {
          // unsetCurrentUser синхронно читает текущий маршрут и для consent
          // сохраняет полный from до перехода на форму входа.
          store.commit("unsetCurrentUser");
        },
      });
    }
    return Promise.reject(error); // this is the important part
  }
);

Vue.use(ReadMore);
Vue.use(VTooltip);
Vue.use(fullscreen);
// Язык браузера для Google Maps
const browserLang = (window.navigator.userLanguage || window.navigator.language).split('-')[0] || 'en';

Vue.use(GmapVue, {
  load: {
    key: "AIzaSyBI4BMTVdrBw_p4rjxkseNpQ_F4x_sW1LE",
    libraries: "places", // This is required if you use the Autocomplete plugin
    language: browserLang,
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'gmap-vue/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
});
Vue.component("cluster", GmapCluster);
Vue.use(VueTour);

// Vue.use(CrispChat, {
//   websiteId: "d6ec8f7f-16a7-46bc-805a-7b0d1da8962e",
//   disabled: false,
//   hideOnLoad: true,
//   session_merge: true,
// });
Crisp.configure("d6ec8f7f-16a7-46bc-805a-7b0d1da8962e", {
  autoload: true,
  hideOnLoad: true,
  session_merge: true,
});
// Пузырь чата скрыт ВЕЗДЕ (веб, натив, кабинет клиента /client_page):
// чат открывается только из меню «Поддержка» в дровере
// (Drawer.openSupportChat). После закрытия чата прячем пузырь снова.
window.$crisp = window.$crisp || [];
window.$crisp.push(["do", "chat:hide"]);
window.$crisp.push(["on", "chat:closed", () => window.$crisp.push(["do", "chat:hide"])]);

// Vue.use(OneSignalVue);

let app;

// FT-191: общий компьютер. До монтирования — по persisted-данным, без сети: если сессия в режиме
// устройства, а человек отсутствовал дольше таймаута (сон, закрытый браузер), экран блокируется
// до первой отрисовки страницы.
(function bootDeviceLock() {
  if (shouldBootLock(store.state.deviceLock, Date.now(), readLastActivity())) {
    store.dispatch('deviceLock/lock'); // экран и токен — сразу, отзыв на сервере — сохранённым токеном
  }
  // Открылись заблокированными — страница под экраном без данных; после разблокировки — перезагрузка.
  if (store.state.deviceLock.locked) markBootedLocked();
})();
startDeviceIdleTracker(store);

// Текст для ИИ-агентов в браузере: интерфейсом пользоваться можно, внутренним API — нет.
printAgentNotice();

if (!app) {
  app = new Vue({
    el: "#app",
    router,
    store,
    // securedAxiosInstance,
    // plainAxiosInstance,
    components: { App },
    vuetify,
    i18n,
    watch: {
      // Единая точка синхронизации внутренних строк Vuetify (таблицы, пикеры,
      // пагинация) с локалью приложения: смена языка идёт из разных мест
      // (Signin/Signup/Profile/Footer), а lang.current сам не следует за $i18n
      "$i18n.locale": {
        handler(locale) {
          const current = vuetifyLocaleFor(locale);
          this.$vuetify.lang.current = current;
          // Подпись пагинации Vuetify («Wierszy na stronie» / «Filas por página»)
          // расходится с проектным термином custom.elements_table, видимым на
          // соседних таблицах. Приводим пак к проектному термину для любого языка;
          // dataTable — v-data-table, dataFooter — v-data-iterator.
          const label = this.$i18n.t("custom.elements_table");
          const pack = this.$vuetify.lang.locales[current];
          if (pack && typeof label === "string" && !label.includes("elements_table")) {
            pack.dataTable = { ...pack.dataTable, itemsPerPageText: label };
            pack.dataFooter = { ...pack.dataFooter, itemsPerPageText: label };
          }
        },
        immediate: true
      }
    },
    // Помогло убрать ошибку runtime-only or standalone
    render: (h) => h(App)
  });
}
